module.exports = __webpack_public_path__ + "static/media/md-analytics.2688d275.svg";